import { render, staticRenderFns } from "./old_edit.vue?vue&type=template&id=48df6b39&scoped=true"
import script from "./old_edit.vue?vue&type=script&lang=ts"
export * from "./old_edit.vue?vue&type=script&lang=ts"
import style0 from "./old_edit.vue?vue&type=style&index=0&id=48df6b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df6b39",
  null
  
)

export default component.exports